import {
  BUTTON_GO_BACK,
  BUTTON_WHY_THIS_RECOMMENDATION,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DialogActions from "@mui/material/DialogActions";
import ModalBasicLayout from "../../../../components/Modal/ModalBasicLayout";
import ContainerModalActions from "../../../../components/Containers/ContainerModalActions";

const ModalInsightReasoning = ({ modalOpen, onCloseModal, insight }) => {
  const { t } = useTranslationApp();
  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth={true}
      maxWidth="sm"
      title={t(BUTTON_WHY_THIS_RECOMMENDATION)}
    >
      <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="body1">{insight.reasoning}</Typography>
        <Typography variant="body1">{insight.action}</Typography>
      </Box>
      <DialogActions sx={{ p: 0 }}>
        <ContainerModalActions
          hasPadding={true}
          propsSecondaryButton={{
            showButton: true,
            onClick: onCloseModal,
            text: BUTTON_GO_BACK,
          }}
          propsPrimaryButton={{
            showButton: false,
          }}
        />
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default ModalInsightReasoning;
